const translations = {
  currentLanguage: 'Current language',
}

export default translations
